import { useMemo } from "react";

import type { Permission } from "@/features/roleAccess";
import { useRole } from "@/features/roleAccess";

export type { Permission };

const useAuthorized = (permissions?: Permission[]) => {
  const { hasPermission } = useRole();

  const isAuthorized = useMemo(
    () => !permissions || permissions.some(hasPermission),
    [permissions, hasPermission],
  );

  return isAuthorized;
};

export default useAuthorized;
